'use client';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ToastProvider = () => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={500}
      hideProgressBar
      newestOnTop
      closeOnClick
      pauseOnFocusLoss={false}
      pauseOnHover
    />
  );
};

export const TOAST = {
  success: (text: string) => toast.success(text),
  error: (text: string) => toast.error(text),
  dissmiss: () => toast.dismiss()
};
